import { render, staticRenderFns } from "./test.vue?vue&type=template&id=6abda59c&scoped=true"
import script from "./test.vue?vue&type=script&lang=js"
export * from "./test.vue?vue&type=script&lang=js"
import style0 from "./test.vue?vue&type=style&index=0&id=6abda59c&prod&lang=css"
import style1 from "./test.vue?vue&type=style&index=1&id=6abda59c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6abda59c",
  null
  
)

export default component.exports